import { GetCategoryVariableColorMapResponse } from '@/api/dashboards/getCategoryVariableColorMap';
import decreaseArrow from '@/svgs/decreaseArrow.svg';
import increaseArrow from '@/svgs/increaseArrow.svg';
import { jsxToHtml } from '@/utils/reactUtils';
import { buildWrappedNameFragment } from '@/utils/stringUtils';
import { CategoryData, ChartOptions } from './OptimizedPieChart';
import { OptimizedPieTooltip } from './OptimizedPieTooltip';

export const budgetShareChartOptions = ({
    showPercent,
    data,
    formatNumber,
    colorMap,
}: {
    colorMap: GetCategoryVariableColorMapResponse;
    showPercent: boolean;
    data: CategoryData[];
    formatNumber: (num: number) => string;
}): ChartOptions => {
    return {
        legend: {
            show: false,
        },
        animation: true,
        tooltip: {
            trigger: 'item',
            triggerOn: 'mousemove|click',
            backgroundColor: 'transparent',
            borderWidth: 0,
            padding: 0,
            type: 'item',
            formatter: (p) => {
                return jsxToHtml(
                    <OptimizedPieTooltip
                        {...p}
                        value={formatNumber(p.value)}
                    />,
                );
            },
        },
        series: [
            {
                name: 'Access From',
                type: 'pie',
                radius: '55%',
                width: '100%',
                color: '#fff',
                left: -0,
                label: {
                    position: 'outer',
                    alignTo: 'labelLine',
                    minMargin: 10,
                    show: true,
                    backgroundColor: 'transparent',
                    borderWidth: 1,
                    borderRadius: 5,
                    color: '#fff',
                    fontSize: 14,
                    align: 'center',
                    rich: {
                        per: {
                            padding: [5, 0],
                            align: 'center',
                            color: '#eee',
                            fontSize: 16,
                        },
                        arrow: {
                            padding: [5, 0],
                            height: 12,
                            width: 13,
                            align: 'center',
                        },
                        num: {
                            fontSize: 16,
                            align: 'center',
                        },
                    },
                },
                data: data.map(({ name, budget, percent }) => {
                    return {
                        value: budget,
                        name,
                        itemStyle: {
                            color: colorMap.categoryColorMap[name],
                        },
                        label:
                            showPercent && percent !== undefined
                                ? {
                                      formatter: `${buildWrappedNameFragment(name)}\n{per|{d}%}\n{arrow| }{num|${percent}%}`,
                                      rich: {
                                          arrow: {
                                              backgroundColor: {
                                                  image:
                                                      percent < 0
                                                          ? decreaseArrow
                                                          : increaseArrow,
                                              },
                                          },
                                          num: {
                                              fontSize: 16,
                                              align: 'center',
                                              color:
                                                  percent < 0
                                                      ? '#FF3766'
                                                      : '#3BE98B',
                                          },
                                      },
                                  }
                                : {
                                      formatter: `${buildWrappedNameFragment(name)}\n{per|{d}%}`,
                                  },
                    };
                }),
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                },
            },
        ],
    };
};
